import { generatePath } from 'react-router';

import paths from './paths';
import isEmpty from './utils/isEmpty';

const getDocumentLink = (id: string) => {
  if (isEmpty(id)) return '';

  // const result = await getDocumentMetadata(
  //   { path: { document_id: id } },
  //   wgApi,
  // );

  // return result.link;

  return '';
};

export default function transformDeeplink(deeplink: string) {
  if (isEmpty(deeplink.trim())) return '';

  const [, kind, id] = deeplink.split(':');

  switch (kind) {
    case 'policy':
      return generatePath(paths.policies.detail, { id });
    case 'policy_package':
      return generatePath(paths.policyPackages.detail, { id });
    case 'risk_object':
      return generatePath(paths.riskObjects.detail, { id });
    case 'claim':
      return generatePath(paths.claims.detail, { id });
    case 'invoice':
      return generatePath(paths.invoices.detail, { id });
    case 'document':
      return getDocumentLink(id ?? '');
    default:
      return deeplink;
  }
}
